module.exports = __webpack_public_path__ + "img/ico-double-arrows-right.873d4e55.svg";